<template>
  <base-floating-card>
    <div id="event-add-location-card">
      <div id="add-location-art">
        <h5>Add Location To Event</h5>
        <add-location-art class="art" />
      </div>
      <div id="search-components">
        <Input
          id="location-search-input"
          heading="Search for location"
          @scs-input="searchForLocation"
        />
        <div id="location-search-results">
          <location-search-item
            class="location-search-item"
            v-for="(result, index) in dbSearchResults"
            :key="index"
            :title="result.title"
            :body="result.body"
            source="db"
            @click="selectDBSearchLocation(result.location, index)"
          />
          <location-search-item
            class="location-search-item"
            v-for="(result, index) in awsSearchResults"
            :key="index"
            :title="result.title"
            :body="result.body"
            source="search"
            @click="selectAWSSearchLocation(result, index)"
          />
          <location-search-item
            class="location-search-item"
            v-for="num in !searchTerm &&
            awsSearchResults.length === 0 &&
            dbSearchResults.length === 0
              ? 5
              : 0"
            :key="num"
            source="skeleton"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import Input from "../../../Elements/Input.vue";
import LocationSearchItem from "../../../UI/ListItems/Location/Search.vue";
import AddLocationArt from "../../../UI/Illustrations/AddLocation.vue";
export default {
  data() {
    return {
      timer: undefined,
      dbSearchResults: [],
      awsSearchResults: [],
      loading: undefined,
      searchTerm: undefined,
    };
  },
  computed: {},
  methods: {
    async searchForLocation(value) {
      this.loading = true;
      this.searchTerm = value;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        if (value.length > 3) {
          await this.$store
            .dispatch("searchAWSForLocation", value)
            .then((res) => {
              this.awsSearchResults = res.map((x) => {
                return this.processAWSSearchResult(x);
              });
            });
          this.loading = false;
        }
      }, 800);
    },
    processAWSSearchResult(result) {
      let [title, ...description] = result.Text.split(", ");
      return {
        title: title,
        body: description.join(", "),
      };
    },
    processDBSearchResult(result) {
      switch (result.api_version) {
        case "9-28-2022":
          return {
            location: result,
            title: result.Name,
            body: result.Label,
            source: result.source,
          };
        default:
          // for non-api-versioned locations, result.api_version return undefined
          return {
            location: result,
            title: result.name,
            body: Object.values(result.address).reduce((acc, x) => {
              if (x) {
                return acc + ", " + x;
              } else {
                return acc;
              }
            }),
            source: "db",
          };
      }
    },
    async selectAWSSearchLocation(result) {
      let location = await this.$store.dispatch(
        "getAWSLocationDetails",
        result.body
      );
      location.Name = result.title;
      location.api_version = "9-28-2022";
      location.source = "search";
      this.addLocationToEvent(location);
    },
    selectDBSearchLocation(result) {
      result.source = "db";
      this.addLocationToEvent(result);
    },
    addLocationToEvent(location) {
      let parameters = {
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
        tenantId: this.$store.state.user.tenantId,
        source: location.source,
        location: location,
      };
      this.$store.dispatch("addLocationToEvent", parameters);
      this.$emit("close");
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    Input,
    LocationSearchItem,
    AddLocationArt,
  },
  props: ["event"],
};
</script>
<style scoped>
@media screen {
  #event-add-location-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .art {
    width: 100px;
  }
  h5 {
    margin: 0;
  }
  #search-components {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #location-search-input {
    width: 100%;
  }

  #location-search-results {
    overflow: scroll;
    padding: 20px;
    width: 100%;
  }

  .location-search-item {
    width: 100%;
  }
  @media (min-width: 800px) {
    #event-add-location-card {
      display: flex;
      flex-direction: row;
      min-width: 600px;
      height: 300px;
      justify-content: space-between;
      align-items: center;
    }

    .art {
      width: 100px;
    }

    #search-components {
      width: 450px;
      height: 80%;
      padding-left: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #location-search-input {
      width: 80%;
    }

    #location-search-results {
      overflow: scroll;
      padding: 20px;
      width: 80%;
    }

    .location-search-item {
      width: 100%;
    }
  }
}
</style>
